import { DownloadOutlined } from "@ant-design/icons";
import { HiOutlineLockClosed } from "react-icons/hi";
import { LuMessageCircleQuestion } from "react-icons/lu";

const routeConfigFinance = [
  {
    id: "finance-group",
    title: "Finance Operations",
    messageId: "sidebar.finance",
    type: "group",
    children: [
      {
        id: "download-pdf",
        title: "Download PDF",
        messageId: "menu.download-pdf",
        icon: <DownloadOutlined />,
        path: "/download-pdf",
      },
      {
        id: "settings",
        title: "Settings",
        messageId: "menu.settings",
        icon: (
          <span className="material-symbols-outlined" style={{ fontSize: 20 }}>
            settings
          </span>
        ),
        type: "collapse",
        children: [
          {
            id: "changepassword",
            title: "Change Password",
            messageId: "menu.cp",
            icon: <HiOutlineLockClosed />,
            path: "/changepassword",
          },
        ],
      },
      {
        id: "Help&Support",
        title: "Help & Support",
        messageId: "menu.track",
        icon: <LuMessageCircleQuestion />,
        path: "/Help&Support",
      },
    ],
  },
];

export function useRouteConfigFinance() {
  return routeConfigFinance;
}

export default routeConfigFinance;
